import React from "react";
import {
  Box,
  Card,
  Button,
  CardContent,
  Typography,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { AvatraBox } from "../AvatarBox";

export const ChildCard = ({ user = {}, onclick, color }) => {
  return (
    <Card
      sx={{
        borderRadius: "16px",
        overflow: "hidden",
        width: "100%",
        maxWidth: 360,
        mx: "auto",
        boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
        background: "#fff",
      }}
    >
      {/* Gradient Header */}
      <Box
        sx={{
          height: 100,
          background: "linear-gradient(180deg, #e779a5ff 0%, #ff3385 100%)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        {/* Avatar positioned overlapping the white card section */}
        <Box
          sx={{
            position: "absolute",
            bottom: "-30px",
            borderRadius: "50%",
            backgroundColor: "#fff",
            padding: "3px",
          }}
        >
          <AvatraBox user={user} size={70} />
        </Box>
      </Box>

      {/* Content */}
      <CardContent
        sx={{
          textAlign: "center",
          pt: 5,
          pb: 3,
        }}
      >
        <Typography
          variant="h6"
          fontWeight="600"
          color="text.primary"
          gutterBottom
          textTransform="capitalize"
        >
          {user.firstName} {user.lastName}
        </Typography>

        <Button
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          onClick={onclick}
          sx={{
            mt: 1.5,
            textTransform: "uppercase",
            borderRadius: "8px",
            px: 3,
            py: 1,
          }}
        >
          View Products and Reports
        </Button>
      </CardContent>
    </Card>
  );
};
